import { action, computed, observable, makeAutoObservable } from 'mobx';
import { FormInputState, FormModel } from 'src_common/common/mobx-utils/Form';
import React from 'react';

type EventHandlers = 'onFocus' | 'onChange' | 'onBlur' | 'onInput';

export class InputState {
    @observable isFocus: boolean = false;

    constructor(
        private readonly inputState: FormInputState<string>,
        private readonly inputModel: FormModel<string | number | null>,
        private readonly eventHandlers: Partial<
            Record<EventHandlers, (event: React.SyntheticEvent<HTMLInputElement>) => void>
        >
    ) {
        makeAutoObservable(this);
    }

    @action handleFocus = (event: React.FocusEvent<HTMLInputElement>): void => {
        this.isFocus = true;
        if (this.eventHandlers.onFocus) {
            this.eventHandlers.onFocus(event);
        }
    };

    @action handleBlur = (event: React.SyntheticEvent<HTMLInputElement>): void => {
        this.isFocus = false;
        this.inputState.setAsVisited();
        if (this.eventHandlers.onBlur) {
            this.eventHandlers.onBlur(event);
        }
    };

    @action handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.currentTarget.value;

        this.inputState.setValue(value);
        this.inputState.setAsVisited();
        if (this.eventHandlers.onChange) {
            this.eventHandlers.onChange(event);
        }
    };

    @action handleInput = (event: React.SyntheticEvent<HTMLInputElement>): void => {
        if (this.eventHandlers.onInput) {
            this.eventHandlers.onInput(event);
        }
    };

    @computed get value(): string {
        return this.inputState.value;
    }

    @computed get isEmpty(): boolean {
        return this.inputState.value.length === 0;
    }

    @computed get errorMessage(): string | null {
        return this.inputModel.errorMessage;
    }
}
